import {
  alertPanel_warningBorder,
  base_colorContentBorder,
  base_colorRaisedSurface,
  cta_buttonPrimaryText,
  text_colorTextPrimary,
  text_colorTextSecondary,
  tooltip_colorDefaultSurface,
  tooltip_colorSpotlightSurface,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
  font_xl,
  font_xs,
  fontH1,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: min(100%, 790px);
  display: grid;
  grid-template-columns: minmax(0, 415fr) minmax(0, 375fr);
  min-height: 300px;
  overflow: hidden;
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(5.5)};
  background: ${base_colorRaisedSurface};
  box-shadow: 0 ${spacing(4.5)} ${spacing(12.5)} -${spacing(5.5)}
    ${text_colorTextPrimary}38;

  .PromotionSavingsHero-copy {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: ${spacing(4)};
    padding: ${spacing(9)} ${spacing(10)};
  }

  .PromotionSavingsHero-brand {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
  }

  .PromotionSavingsHero-logo {
    width: ${spacing(7)};
    height: ${spacing(4)};
    object-fit: contain;
  }

  .PromotionSavingsHero-eyebrow {
    ${font_xs};
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_medium};
    letter-spacing: 0.1em;
  }

  .PromotionSavingsHero-headline {
    ${font_xl};
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
  }

  .PromotionSavingsHero-description {
    ${font_md};
    color: ${text_colorTextSecondary};
  }

  .PromotionSavingsHero-pricing {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: ${spacing(4.5)};
    padding: ${spacing(8)} ${spacing(7)} ${spacing(7)};
    background: linear-gradient(
      90deg,
      ${tooltip_colorDefaultSurface} 0%,
      ${tooltip_colorSpotlightSurface} 100%
    );
  }

  .PromotionSavingsHero-firstYearPriceLabel {
    ${font_xs};
    display: flex;
    align-items: center;
    gap: ${spacing(1.5)};
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  .PromotionSavingsHero-firstYearPriceLabel span,
  .PromotionSavingsHero-freeSeats span {
    color: ${alertPanel_warningBorder};
  }

  .PromotionSavingsHero-firstYearPriceSummary {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
  }

  .PromotionSavingsHero-firstYearPriceAmount {
    ${fontH1};
    color: ${cta_buttonPrimaryText};
  }

  .PromotionSavingsHero-savingsDetail {
    ${font_sm};
    color: ${cta_buttonPrimaryText};
  }

  .PromotionSavingsHero-divider {
    width: 100%;
    min-height: 1px;
    background: ${cta_buttonPrimaryText}26;
  }

  .PromotionSavingsHero-paymentSummary {
    ${font_sm};
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
  }

  .PromotionSavingsHero-discountedPrice {
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
  }

  .PromotionSavingsHero-standardPrice {
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
  }

  .PromotionSavingsHero-freeSeats {
    ${font_xs};
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: ${spacing(1)};
    padding: ${spacing(1)} ${spacing(2.5)};
    border-radius: 999px;
    border: 1px solid ${cta_buttonPrimaryText}38;
    background: ${cta_buttonPrimaryText}29;
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    min-height: 0;

    .PromotionSavingsHero-copy,
    .PromotionSavingsHero-pricing {
      padding: ${spacing(6)};
    }

    .PromotionSavingsHero-headline,
    .PromotionSavingsHero-firstYearPriceAmount {
      ${font_xl};
    }
  }
`
